import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const { user, can } = useAuth();
  const role = user?.role || "";
  const [theme, setTheme] = useState(() => localStorage.getItem("ct_theme") || "dark");
  const [hub, setHub] = useState(() => localStorage.getItem("ct_hub") || "All");
  const [quickEntryDp, setQuickEntryDp] = useState(null);
  const [insightsOpen, setInsightsOpen] = useState(false);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("ct_theme", theme);
  }, [theme]);
  useEffect(() => localStorage.setItem("ct_hub", hub), [hub]);

  const value = {
    role, theme, setTheme, hub, setHub,
    toggleTheme: () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    quickEntryDp, openQuickEntry: setQuickEntryDp, closeQuickEntry: () => setQuickEntryDp(null),
    insightsOpen, setInsightsOpen,
    can,
  };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
